export default __webpack_public_path__ + "static/media/banner_img2.2f346792.gif";